import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { gapi, errMsg } from "../api";
import { AuthShell, Field, Submit, Notice, PASSWORD_HINT } from "../components/AuthShell";

function Forgot() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState({});
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setMsg({});
    try { await gapi.post("/auth/password/forgot", { email }); setMsg({ ok: "Se l'email corrisponde a un account attivo, riceverai un link valido 60 minuti." }); }
    catch (e2) { setMsg({ err: errMsg(e2) }); } finally { setLoading(false); }
  };
  return (
    <AuthShell title="Recupera la password" subtitle="Ti invieremo un link personale e monouso." testid="g-forgot-form">
      {msg.err && <Notice>{msg.err}</Notice>}
      {msg.ok && <Notice kind="ok" testid="g-forgot-ok">{msg.ok}</Notice>}
      <form onSubmit={submit}>
        <Field label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="g-forgot-email" />
        <Submit loading={loading} data-testid="g-forgot-submit">Invia link</Submit>
      </form>
      <Link to="/gestionale/accesso" className="block mt-6 text-sm text-anthracite/50 hover:underline">Torna all'accesso</Link>
    </AuthShell>
  );
}

function Reset({ token }) {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [msg, setMsg] = useState({});
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setMsg({ err: "Le password non coincidono" });
    setLoading(true); setMsg({});
    try { await gapi.post("/auth/password/reset", { token, password: pw }); setMsg({ ok: true }); }
    catch (e2) { setMsg({ err: errMsg(e2) }); } finally { setLoading(false); }
  };
  if (msg.ok) return (
    <AuthShell title="Password aggiornata" testid="g-reset-done">
      <Notice kind="ok">Per sicurezza tutte le sessioni aperte sono state chiuse.</Notice>
      <Link to="/gestionale/accesso" className="block text-center rounded-full bg-brand text-white font-semibold py-3.5">Accedi</Link>
    </AuthShell>
  );
  return (
    <AuthShell title="Nuova password" testid="g-reset-form">
      {msg.err && <Notice testid="g-reset-error">{msg.err}</Notice>}
      <form onSubmit={submit}>
        <Field label="Nuova password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" required data-testid="g-reset-password" />
        <Field label="Ripeti password" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" required data-testid="g-reset-password2" />
        <p className="text-xs text-anthracite/50 -mt-2 mb-5">{PASSWORD_HINT}</p>
        <Submit loading={loading} data-testid="g-reset-submit">Salva password</Submit>
      </form>
    </AuthShell>
  );
}

export default function RecuperoPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  return token ? <Reset token={token} /> : <Forgot />;
}
